import { ExternalUsersRequestStatusTypes } from '~common/constants';
import { FetchExternalUsersRequestsRoutine, CreateExternalUserByRequestRoutine, RejectExternalUserRequestRoutine } from '../redux-routines';
import { IUserRequest } from '../interfaces/UserRequest.inteface';

interface IState {
  isFetching: boolean,
  data: any[],
  error: any
}
const initialState: IState = {
  isFetching: false,
  data: [],
  error: null
};

export const externalUsersRequestsReducer = (
  state: IState = initialState,
  action: { type: string, payload: any }
) => {
  switch (action.type) {
    case FetchExternalUsersRequestsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchExternalUsersRequestsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchExternalUsersRequestsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case CreateExternalUserByRequestRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case CreateExternalUserByRequestRoutine.SUCCESS:
      const data: IUserRequest[] = state.data.map((request) => {
        return action.payload.data.requestedExternalUserId === request?.requestedExternalUserId
          ? ({...request, status: ExternalUsersRequestStatusTypes.approved})
          : request;
      });
      return {
        ...state,
        isFetching: true,
        data,
        error: null
      };
    case CreateExternalUserByRequestRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case RejectExternalUserRequestRoutine.REQUEST:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case RejectExternalUserRequestRoutine.SUCCESS:
      const results: IUserRequest[] = state.data.filter((request) => (
        action.payload.data.requestedExternalUserId !== request?.requestedExternalUserId
      ));
      return {
        ...state,
        isFetching: true,
        data: results,
        error: null
      };
    case RejectExternalUserRequestRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};